module.exports = __webpack_public_path__ + "img/monokai-village.ea70781b.png";